import React from 'react';
import PropTypes from 'prop-types';
import {
  summarySummaryVFModalFieldData,
  formDataShape,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import {
  ModalSummary,
} from 'AppSrc/core/components/forms/form-base-components/summary-components/modal-summary/modal-summary';
import {
  SUMMARY_SECTION_V_F_MODAL,
} from 'AppSrc/core/components/forms/form-base-components/summary-components/modal-summary/modal-summary-constants';

const SummaryVFModal = React.memo(({
  fieldData,
  selectedNetwork,
  formData,
}) => {

  const {
    vFTypeSpecificOptions,
    value,
  } = fieldData;

  const {
    modalSummaryType,
  } = vFTypeSpecificOptions;

  return (
    <div className="summary-field-v-f-modal">
      <ModalSummary
        modalSummaryType={modalSummaryType}
        displayType={SUMMARY_SECTION_V_F_MODAL}
        modalData={value}
        editItem={null}
        deleteItem={null}
        selectedNetwork={selectedNetwork}
        formData={formData}
      />
    </div>
  );
});

SummaryVFModal.propTypes = {
  fieldData: summarySummaryVFModalFieldData,
  formData: formDataShape,
  selectedNetwork: PropTypes.string,
};

export { SummaryVFModal };

